import React, { useEffect, useState } from "react";

import ClientHeader from "@/Components/common/client/header/ClientHeader";
import "@/assets/css/index.scss";
import ClientSidebar from "@/Components/common/client/header/ClientSidebar";
import CreateChatTemplate from "@/Components/modals/client/consultant/CreateChatTemplate";
import EditChatTemplate from "@/Components/modals/client/consultant/EditChatTemplate";
import OurServicesModal from "@/Components/modals/client/OurServicesModal";
import SubBranchesModal from "@/Components/modals/client/SubBranchesModal";
import QrCodeModal from "@/Components/modals/QrCodeModal";
import TermsConditionModal from "@/Components/modals/TermsConditionModal";
import { resetChatModule } from "@/reducers/chat";
import { updateClientQrCode } from "@/reducers/clientcommon";
import { resetContractDetail } from "@/reducers/clientcontractdetail";
import { resetPage as resetCreateJob } from "@/reducers/clientcreatejob";
import { updateUser } from "@/reducers/clientprofile";

import { useDispatch, useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";

import useIdleTimeout from "@/utilities/hooks/useIdleTimeout";
import { showErrorToast } from "@/utilities/utils";

import SocketLayout from "./SocketLayout";

import Chat from "@/Components/common/chat/Chat";

import { Outlet, useLocation } from "react-router-dom";

import UpdateLoginAnnouncementModal from "../Components/modals/client/announcementModal/UpdateLoginAnnouncementModal";
import { SESSION_EXPIRY_TIME } from "../Constants/common";
import { routingConstants } from "../Constants/routingConstants";
import { saveState } from "../localStorage";
import EmailRedirectRouting from "../Pages/EmailRedirectRouting";
import { setSession } from "../reducers/session";
import store from "../store";
/**
 * Main client component for handling session data and user updates.
 *
 * @param {Object} children - the child components
 * @return {JSX.Element} the main client component
 */
export default function MainClient({ children }) {
  const { session, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );
  const { user } = useSelector((state) => state.clientProfile);
  const { sideBarCollapsed } = useSelector((state) => state.clientCommon);
  const [value, setValue] = useState("");
  let location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    toast.remove();
    dispatch(resetContractDetail());
    dispatch(resetChatModule());
    dispatch(resetCreateJob());
  }, [location]);

  useEffect(() => {
    const {
      user_id,
      user_type,
      email,
      user_token,
      role_name,
      client_id,
      firstname,
      lastname,
      client_sub_branches,
      is_headoffice,
      original_user = "",
      profile_image,
      client_manager_name,
      client_practice_code,
      client_allow_publish_job,
      flashMessage = null,
      qr_code,
      server_url,
      chat_url,
      qr_code_key,
      qr_code_updated_at,
      client_consultant_email,
      client_user_email,
      is_view_user_tour,
      client_address,
      client_phone_number,
      client_ref_number,
      client_name,
      client_branch_name,
      position_name,
      is_primary_contact,
      login_as,
      is_bank_client,
      client_allow_appchat_broadcast,
      client_allow_e_compliance,
    } = session;
    if (flashMessage) {
      const callback = () => {
        showErrorToast(flashMessage, {
          id: "flashMessage",
        });
      };
      dispatch(
        setSession({
          flashMessage: null,
          callback,
        }),
      );
    }
    let user = {
      id: user_id,
      type: user_type,
      email: email,
      token: user_token,
      role_name: role_name,
      client_id: client_id,
      firstname: firstname,
      lastname: lastname,
      profile_image: profile_image,
      is_headoffice: is_headoffice,
      original_user: original_user,
      client_manager_name: client_manager_name,
      client_practice_code: client_practice_code,
      client_allow_publish_job: client_allow_publish_job,
      client_consultant_email: client_consultant_email,
      client_user_email: client_user_email,
      is_view_user_tour: is_view_user_tour,
      client_address: client_address,
      client_ref_number: client_ref_number,
      client_phone_number: client_phone_number,
      client_branch_name: client_branch_name ? client_branch_name : client_name,
      client_postion_name: position_name,
      is_primary_contact: is_primary_contact,
      login_as: login_as,
      is_bank_client: is_bank_client,
      client_allow_appchat_broadcast: client_allow_appchat_broadcast,
      client_allow_e_compliance: client_allow_e_compliance,
    };
    dispatch(updateClientQrCode({ qr_code, qr_code_key, qr_code_updated_at }));
    dispatch(updateUser(user));
    // dispatch(updateClientBranches(client_sub_branches));
    // router.on('cancel', (event) => {
    //   if (!confirm('Are you sure you want to navigate away?')) {
    //     event.preventDefault()
    //   }
    // })
    // router.on("start", (event) => {

    //   // console.log(`Starting a visit to ${event.detail.visit.url}`)
    // });
  }, [session]);
  useEffect(() => {
    saveState(store.getState());
  }, [user]);
  // useEffect(() => {
  //   dispatch(getTotalUnreadCount());
  // }, []);
  useIdleTimeout(SESSION_EXPIRY_TIME);

  if (window.location.pathname.includes("&flag=1")) {
    window.location.href = routingConstants.invoice;
    localStorage.setItem("flag", "true");
  }

  // useEffect(() => {
  //   toast.dismiss(); // Dismiss any existing toasts
  // }, [location.pathname])

  return (
    <SocketLayout>
      <div
        className={`MainClient_wrapper relative min-h-screen bg-gray bg-grey ${
          sideBarCollapsed ? "md:pl-[88px]" : "md:pl-[231px]"
        } font-openSans`}
      >
        <Toaster position="top-center" duration={50000} />
        {/* {
          APP_ENV === "local" || APP_ENV === "development" ?
            <Tour />
            : null
        } */}
        <TermsConditionModal />
        <OurServicesModal />
        <QrCodeModal />
        <SubBranchesModal />
        <ClientSidebar />
        <ClientHeader />
        <CreateChatTemplate />
        <EmailRedirectRouting />
        <UpdateLoginAnnouncementModal />
        <EditChatTemplate value={value} setValue={setValue} />
        <div
          key={location.pathname}
          className="relative min-h-[calc(100vh-56px)] px-3 py-3 md:min-h-[calc(100vh-70px)] md:px-[23px] md:py-4"
        >
          <Outlet />
        </div>
        {clientUserAllPermissions ||
        clientUserAllPermissions?.is_allow_to_chat === 1 ? (
          <>
            <Chat />
          </>
        ) : null}
      </div>
    </SocketLayout>
  );
}
